module.exports = __webpack_public_path__ + "static/media/v360.309e30a4.png";